import React, { useEffect, useState } from "react"
import { useTranslation } from "next-i18next"
import { useDispatch } from "react-redux"
import { useRouter } from "next/router"
import { useSelector } from "react-redux"
import _get from "lodash/get"
import _isEmpty from "lodash/isEmpty"
import {
  getCart,
  createCart,
  addToCart,
  selectCartState,
  setCardStatus,
} from "@/store/features/cartSlice"
import OrderStatusView from "@/components/Shared/OrderStatus/v1/OrderStatus.view"
import { getTranslations } from "@/utils/localization"
import { showToast } from "@/store/features/genericSlice"
import { selectAuthState } from "@/store/features/authSlice"
import { getConfig } from "@/constants/config"
import { FRAUD_CHLLENGE_STATUS } from "@/constants/"
import { getShortenedUrl } from "@/utils/location"
import { fetchOrderDataByEmailOrderId } from "@/utils/orders"
import OrderStatusFiller from "@/components/Shared/OrderStatus/v1/OrderStatusFiller"
import { getCurrency } from "@/utils/helper"
import { getOrderDetailsUrl } from "@/utils/"
import {
  IN_REVIEW_ORDER_STATUS,
  ORDER_IN_RECEIVED_STATUS,
} from "@/constants/index"

const OrderStatus = ({ data }) => {
  // #ToDo Contact number needs to get from authdata
  const contactNumber = data?.contactnumber ?? "NIL"
  const {
    cartcontactDetails = [],
    modalDescription = "",
    modalTitle = "",
    ctaPhoneNumber = "",
    ctaRedirectingURL = "",
    submittedModalTitle = "",
    submittedModalDescription = "",
  } = data ?? {}

  const inReviewModalInfo = {
    modalTitle,
    modalDescription,
    ctaPhoneNumber,
    ctaRedirectingURL,
    submittedModalTitle,
    submittedModalDescription,
  }

  const { isAuth, user } = useSelector(selectAuthState)
  const { isCartLoading = false } = useSelector(selectCartState)
  const [config, setInitialConfig] = useState({})
  const [isReceivedStatus, setIsReceivedStatus] = useState(false)
  const { homeUrl } = config
  const router = useRouter()
  const { t } = useTranslation("common")
  const [i18n, seti18n] = useState({})
  const dispatch = useDispatch()

  useEffect(() => {
    getConfig().then(config => {
      seti18n(getTranslations(t))
      setInitialState(config)
    })
    if (!isCartLoading) {
      dispatch(setCardStatus(true))
      dispatch(getCart())
        .unwrap()
        .then(rsp => {
          if (
            rsp?.cartExists &&
            rsp?.cartExists === "false" &&
            rsp?.error === "No active cart exists."
          ) {
            getCurrency().then(currency => {
              const cartPayload = {
                currency: currency,
                taxMode: "ExternalAmount",
              }
              dispatch(createCart(cartPayload))
                .unwrap()
                .then(() => {
                  dispatch(setCardStatus(false))
                })
            })
          } else if (rsp?.lineItems?.length) {
            dispatch(setCardStatus(false))
            const payload = {
              actions: [
                {
                  action: "recalculate",
                  updateProductData: true,
                },
              ],
            }
            dispatch(addToCart(payload))
          }
        })
    }
  }, [])

  useEffect(() => {
    if (user && isAuth && config.orderHistoryUrl) {
      router.push(config.orderHistoryUrl)
    }
  }, [user, isAuth, config.orderHistoryUrl])

  const setInitialState = async config => {
    const homeUrl = await getShortenedUrl(
      _get(config, "general.homepageUrl", "")
    )
    const orderDetailsUrl = await getShortenedUrl(
      _get(config, "general.orderDetailsPath", "")
    )
    const orderHistoryUrl = await getShortenedUrl(
      _get(config, "general.orderHistoryPath", "")
    )
    setInitialConfig({ homeUrl, orderDetailsUrl, orderHistoryUrl })
  }

  const redirect = url => {
    router.push(`${url}`)
  }

  const showToastMessage = payload => {
    dispatch(showToast(payload))
  }

  const findOrder = async (orderNo, email) => {
    const res = await fetchOrderDataByEmailOrderId(email, orderNo)
    const {
      isEmailMatching,
      consumeFluentOrder,
      mainPayload = {},
      results = [],
    } = res
    const { custom: { fields: { fraudChallengeStatus = "" } = {} } = {} } =
      results.find(o => o.custom?.fields?.isParentOrder) ?? {}

    if (consumeFluentOrder && !isEmailMatching) {
      return false
    } else if (res) {
      if (!_isEmpty(mainPayload) || !_isEmpty(results)) {
        const { orderStatus = "" } = mainPayload
        if (
          FRAUD_CHLLENGE_STATUS.includes(fraudChallengeStatus) ||
          IN_REVIEW_ORDER_STATUS.includes(orderStatus) ||
          ORDER_IN_RECEIVED_STATUS.includes(orderStatus)
        ) {
          setIsReceivedStatus(ORDER_IN_RECEIVED_STATUS.includes(orderStatus))
          return "showWarning"
        } else {
          return await getOrderDetailsUrl(email, orderNo)
        }
      }
      return false
    } else return false
  }

  return !_isEmpty(i18n) ? (
    <OrderStatusView
      i18n={i18n}
      homeUrl={homeUrl}
      supportLine={contactNumber}
      cartcontactDetails={cartcontactDetails}
      findOrder={(orderNo, email) => findOrder(orderNo, email)}
      redirect={redirect}
      showToastMessage={showToastMessage}
      inReviewModalInfo={inReviewModalInfo}
      isReceivedStatus={isReceivedStatus}
      setIsReceived={setIsReceivedStatus}
    />
  ) : (
    <OrderStatusFiller />
  )
}

export default OrderStatus
